(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initialized = new WeakSet();

    function getLimit(wrap) {
      return parseInt(getComputedStyle(wrap).getPropertyValue('--rm-height'), 10) || 150;
    }

    function checkReadMore(wrap) {
      const content = wrap.querySelector('[data-read-more-content]');
      if (!content) return;
      if (wrap.classList.contains('is-expanded')) return;
      // Si está oculto (tab inactivo / acordeón cerrado) no se puede medir todavía
      if (content.offsetHeight === 0) return;

      wrap.classList.remove('is-short');
      const fits = content.scrollHeight <= getLimit(wrap) + 10;
      wrap.classList.toggle('is-short', fits);
    }

    function setupReadMore(wrap) {
      if (initialized.has(wrap)) return;
      initialized.add(wrap);

      const content = wrap.querySelector('[data-read-more-content]');
      if (!content) return;

      checkReadMore(wrap);

      // Se vuelve a medir cuando el contenido pasa a ser visible
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => checkReadMore(wrap)).observe(content);
      }

      // Las imágenes dentro de la descripción cambian la altura al cargar
      content.querySelectorAll('img').forEach(img => {
        if (!img.complete) img.addEventListener('load', () => checkReadMore(wrap), { once: true });
      });
    }

    window.initReadMore = function (root) {
      (root || document).querySelectorAll('[data-read-more]').forEach(setupReadMore);
    };

    // Delegado: funciona también con el contenido clonado en sidebar/popup
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-read-more-toggle]');
      if (!btn) return;
      e.preventDefault();

      const wrap = btn.closest('[data-read-more]');
      const content = wrap && wrap.querySelector('[data-read-more-content]');
      if (!content) return;

      const isExpanded = wrap.classList.contains('is-expanded');

      if (!isExpanded) {
        content.style.maxHeight = content.scrollHeight + 'px';
        wrap.classList.add('is-expanded');
        btn.textContent = btn.dataset.textLess;
        btn.setAttribute('aria-expanded', 'true');
        content.addEventListener('transitionend', function handler() {
          if (wrap.classList.contains('is-expanded')) content.style.maxHeight = 'none';
          content.removeEventListener('transitionend', handler);
        });
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.offsetHeight; // fuerza reflow para que anime
        content.style.maxHeight = '';
        wrap.classList.remove('is-expanded');
        btn.textContent = btn.dataset.textMore;
        btn.setAttribute('aria-expanded', 'false');

        const top = wrap.getBoundingClientRect().top;
        if (top < 0) {
          window.scrollBy({ top: top - 100, behavior: 'smooth' });
        }
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => window.initReadMore());
    } else {
      window.initReadMore();
    }
  })();

  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              if (window.initReadMore) window.initReadMore(drawerContent);
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              if (window.initReadMore) window.initReadMore(popupContent);
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
